<template>
    <AuthenticatedLayout>

        <div v-if="$page.props.auth.user.is_demo">
            <DemoBotWarning :current-date="currentDate"/>
        </div>

        <div class="text-4xl mt-4 mb-4">Статистика по всем ботам</div>

        <div class="mb-4">
<!--            <PairsHorisontalMenu-->
<!--                currentPairSymbol="ALL"-->
<!--                :pairsData="pairsData"-->
<!--                :menuPairs="menuPairs"-->
<!--                url=""-->
<!--            />-->

            <div class="surface-ground">
                <div class="flex flex-row justify-content-start">

                    <div class="flex-auto pr-2 max-w-30rem">
                        <div class="surface-card p-3 border-round cursor-pointer hover:bg-blue-50 shadow-3">
                            <div class="flex justify-content-between mb-3">
                                <div class="text-600">
                                    <span class="block text-600 font-medium mb-3" >Профит</span>
                                    <span v-if="todayProfitValue > 0"><span class="text-green-500 font-medium text-2xl">${{todayProfitValue}}</span></span>
                                    <span v-if="todayProfitValue < 0"><span class="text-red-500 font-medium text-2xl">${{todayProfitValue}}</span></span>
                                    <span v-if="todayProfitValue === 0"><span class="text-500 font-medium text-2xl">$0</span></span>
                                </div>
                                <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">
<!--                                    <img v-if="pairData.symbol !== 'ALL'" :src="'/logos/'+pairData.base+'.svg'" style="width:2.5rem;height:2.5rem" class="full-rounded" :alt="pairData.symbol"/>-->
                                </div>
                            </div>
                            <template v-if="yesterdayProfitValue > 0"><span class="font-medium text-lg text-500"><span class="text-green-500">${{yesterdayProfitValue}}</span></span></template>
                            <template v-if="yesterdayProfitValue < 0"><span class="font-medium text-lg text-500"><span class="text-red-500">${{yesterdayProfitValue}}</span></span></template>
                            <template v-if="yesterdayProfitValue === 0"><span class="font-medium text-lg text-500">${{yesterdayProfitValue}}</span></template>
                            <span class="text-500">за вчера</span>
                        </div>
                    </div>


<!--                    <div class="flex-auto pr-2 max-w-30rem">-->
<!--                        <div class="surface-card p-3 border-round cursor-pointer hover:bg-blue-50 shadow-3">-->
<!--                            <div class="flex justify-content-between mb-3">-->
<!--                                <div class="text-600">-->
<!--                                    <span class="block text-600 font-medium mb-3" >Открытые сделки</span>-->
<!--                                    <span class="text-500 font-medium text-2xl">{{openDealsData.count}} на сумму {{round(openDealsData.value, 2)}}</span>-->
<!--                                </div>-->
<!--                                <div class="flex align-items-center justify-content-center full-rounded" style="width:2.5rem;height:2.5rem">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <span class="font-medium text-lg text-500">${{openDealsData.profit}} профит, если всё продать сейчас</span>-->
<!--                        </div>-->
<!--                    </div>-->


                </div>
            </div>
        </div>

        <div class="flex">
            <div class="flex-1">
                <Card>
                    <template #title>
                        Профит за день
                    </template>
                    <template #content>
                        <DataTable :value="dailyProfit" :paginator="true" :rows="5" responsiveLayout="scroll"
                                   paginatorTemplate="PageLinks"
                        >
                            <Column field="date" header="Дата"></Column>
                            <Column header="Grid"><template #body="slotProps"><div v-html="round_colored(slotProps.data.profit_grid, 1)"></div></template></Column>
                            <Column header="Jmc"><template #body="slotProps"><div v-html="round_colored(slotProps.data.profit_jmc, 1)"></div></template></Column>
                            <Column header="Всё"><template #body="slotProps"><div class="text-lg" v-html="round_colored(slotProps.data.profit_total, 1)"></div></template></Column>
                        </DataTable>
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Профит за месяц
                    </template>
                    <template #content>
                        <DataTable :value="monthlyProfit" :paginator="true" :rows="5" responsiveLayout="scroll"
                                   paginatorTemplate="PageLinks"
                        >
                            <Column field="date" header="Месяц"></Column>
                            <Column header="Grid"><template #body="slotProps"><div v-html="round_colored(slotProps.data.profit_grid, 1)"></div></template></Column>
                            <Column header="Jmc"><template #body="slotProps"><div v-html="round_colored(slotProps.data.profit_jmc, 1)"></div></template></Column>
                            <Column header="Всё"><template #body="slotProps"><div class="text-lg" v-html="round_colored(slotProps.data.profit_total, 1)"></div></template></Column>
                        </DataTable>
                    </template>
                </Card>

            </div>
        </div>

        <div class="flex mt-4">
            <div class="flex-1">
                <Card>
                    <template #title>
                        Последние сделки по всем ботам
                    </template>
                    <template #content>
                        <AllDealsTable :deals_data="lastDealsData" />
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Последние логи по всем ботам
                    </template>
                    <template #content>
                        <DataTable :value="logs" selectionMode="single" dataKey="id">
                            <Column header="Дата" >
                                <template #body="slotProps">
                                    {{short_timezoned(slotProps.data.date)}}
                                </template>
                            </Column>
                            <Column header="Бот" >
                                <template #body="slotProps">
                                    <a :href="slotProps.data.link" class="text-blue-500">{{slotProps.data.symbol}}</a>
                                </template>
                            </Column>
                            <Column header="" field="level" ></Column>
                            <Column header="Сообщение" >
                                <template #body="slotProps">
                                    <span>{{slotProps.data.message}}</span>
                                </template>
                            </Column>
                        </DataTable>
                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";
import AllDealsTable from "@/Tables/AllDealsTable.vue";
import LogsTable from "@/Tables/LogsTable.vue";
import DemoBotWarning from "@/Components/DemoBotWarning.vue";
import ProgressSpinner from "primevue/progressspinner";

export default {
    props: {
        todayProfitValue: Number,
        yesterdayProfitValue: Number,
        dailyProfit: Array,
        monthlyProfit: Array,
        lastDealsData: Array,
        logs: Array,
        currentDate: String,
    },
    components:{
        ProgressSpinner,
        DemoBotWarning,
        LogsTable,
        AllDealsTable,
        PairsHorisontalMenu,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link
    },
    data(){
        return {

        }
    },
    computed:{
        sumProfitsByType(){
            let sum = 0;
            this.profitByType.forEach((item) => {
                sum += parseFloat(item.profit);
            })
            return sum;
        }
    },
    methods:{
        ...helperMethods,
    }
}
</script>

